// interface
import {required} from "@free2move/vuejs-components/validators.js";
export default {
    showGlobalLoader: false,
    showTransparentGlobalLoader: false,
    globalTabIndex: 0,
    isAuthenticated: false,
    user: {},
    profile: {
        firstName: {
            validators: [required],
            value: '',
            errors: []
        },
        lastName: {
            validators: [required],
            value: '',
            errors: []
        },
        phoneNumber: {
            validators: [],
            value: '',
            errors: [],
            formatted: ''
        },
        address: {
            validators: [],
            value: '',
            errors: []
        },
        email: {
            value: ''
        },
        profileLoaded: false
    },
}
